import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNativePlatform } from "./platform";

export async function hapticImpact(
  style: ImpactStyle = ImpactStyle.Light,
): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }

  await Haptics.impact({ style });
}

export async function hapticNotification(
  type: NotificationType = NotificationType.Success,
): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }

  await Haptics.notification({ type });
}

export async function hapticSelection(): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }

  await Haptics.selectionChanged();
}
